<ct-lib-modal
  class="nps-modal"
  [closeable]="false"
  [footer]="npsModalFooter"
  [label]="'company-tool.other.net-promoter-score-modal.title' | transloco"
  #npsModal
>
  @if (form === 1) {
    <p
      [innerHTML]="'company-tool.other.net-promoter-score-modal.text' | transloco: { firstName: userAccount.firstName }"
    ></p>
  } @else {
    <p [innerHTML]="secondTitle"></p>
  }
  <div id="hubspotForm" #hubspotForm></div>
</ct-lib-modal>
<ng-template #npsModalFooter>
  <app-button variant="white-grey" (click)="npsModalIgnore.open()">
    {{ 'company-tool.other.net-promoter-score-modal.footer.skip' | transloco }}
  </app-button>
  <app-button (click)="submit()" [disabled]="!valid">
    {{ 'company-tool.other.net-promoter-score-modal.footer.submit' | transloco }}
  </app-button>
</ng-template>

<ct-lib-modal
  class="nps-modal"
  [closeable]="false"
  [footer]="npsModalIgnoreFooter"
  [label]="'company-tool.other.net-promoter-score-modal.ignore-modal.title' | transloco"
  #npsModalIgnore
>
  <p [innerHTML]="'company-tool.other.net-promoter-score-modal.ignore-modal.description' | transloco"></p>
</ct-lib-modal>
<ng-template #npsModalIgnoreFooter>
  <app-button variant="white-grey" (click)="npsModalIgnore.close(); npsModal.close()">
    {{ 'company-tool.other.net-promoter-score-modal.ignore-modal.next-login-btn' | transloco }}
  </app-button>
  <app-button variant="primary" (click)="ignore(); npsModalIgnore.close(); npsModal.close()">
    {{ 'company-tool.other.net-promoter-score-modal.ignore-modal.ignore-button' | transloco }}
  </app-button>
</ng-template>
